import styled from 'styled-components';

import { LightSource } from 'ui/components/Icons/LightSource';

const StyledLightSource = styled(LightSource)`
  position: absolute;
  fill: rgba(149, 209, 241, 0.75);
  filter: blur(100px);
`;
const LightCircle = styled.div`
  border-radius: 261.584px;
  opacity: 0.6;
  background: rgba(33, 85, 119, 0.5);
  width: 261.584px;
  height: 215px;

  filter: blur(40px);
`;
const BackgroundWrapper = styled.div`
  z-index: -1;
  position: absolute;
  left: -50px;
  top: -50px;
`;

export const YearlyBackground = () => {
  return (
    <BackgroundWrapper>
      <StyledLightSource />
      <LightCircle />
    </BackgroundWrapper>
  );
};
